module.exports = __webpack_public_path__ + "img/section2Bg2.d40deaef.webp";